import React from 'react'
import Loading from "../../components/common/Loading";
import dynamic from "next/dynamic";
import Head from "next/head";
import SchemaTags from "@/components/common/SchemaTags";

const DesktopCosmetics = dynamic(() => import('../../components/retail/cosmetics/DesktopCosmetics'), {
  loading: () => <Loading />,

});
const MobileCosmetics = dynamic(() => import('../../components/retail/cosmetics/MobileCosmetics'), {
  loading: () => <Loading />,

});


const cosmetics = ({ mobileView }) => {
  return (
    <>
      <Head>
        <title>Best Cosmetics POS Software With Inventory Billing for your Beauty Store</title>
        <link rel="canonical" href="https://queuebuster.co/retail/cosmetics-pos-billing-software" />
        <link href="https://queuebuster.co/retail/cosmetics-pos-billing-software" hrefLang="en-us" />
        <meta name="description" content="Optimize your beauty store with the best cosmetics POS software. Manage inventory, streamline billing, and enhance customer satisfaction with our comprehensive solution." />
        <meta property="og:title" content="Best Cosmetics POS Software With Inventory Billing for your Beauty Store" />
        <meta property="og:description" content="Optimize your beauty store with the best cosmetics POS software. Manage inventory, streamline billing, and enhance customer satisfaction with our comprehensive solution." />
        <meta property="og:image" content="https://quebuster.s3.ap-south-1.amazonaws.com/assets/outlet-og-img/cosmetics.jpg" />
        <meta property="og:url" content="https://queuebuster.co/retail/cosmetics-pos-billing-software" />

      </Head>
         <SchemaTags page="cosmetics-pos-billing-software" />
      {
        mobileView ? <MobileCosmetics /> : <DesktopCosmetics />
      }
    </>
  )
}

export default cosmetics